// AUTO-GENERATED by build-sfx-sprite.js — do not edit manually
// Run "npm run build:sfx" to regenerate
export const SFX_SPRITE_MAP = {
  "additional_free_spins_intro": [
    0,
    500
  ],
  "additional_free_spins_outro": [
    2000,
    500
  ],
  "additional_free_spins_win": [
    4000,
    1810.2040816326532
  ],
  "basic_win": [
    7000,
    1500
  ],
  "big_win": [
    10000,
    3000
  ],
  "button_click": [
    14000,
    199.9999999999993
  ],
  "coin_land": [
    16000,
    889.6145124716561
  ],
  "collect_activate": [
    18000,
    1733.083900226756
  ],
  "collect_land": [
    21000,
    2299.84126984127
  ],
  "door_opening": [
    25000,
    1112.5396825396833
  ],
  "free_spin_intro": [
    28000,
    2000
  ],
  "free_spin_intro_close": [
    31000,
    2000
  ],
  "gamble_intro": [
    34000,
    3000
  ],
  "gamble_loss": [
    38000,
    1886.780045351472
  ],
  "gamble_outro": [
    41000,
    1832.0634920634902
  ],
  "gamble_spin": [
    44000,
    6721.043083900227
  ],
  "gamble_win": [
    52000,
    1638.25396825397
  ],
  "golden_mystery_reveal": [
    55000,
    1500
  ],
  "golden_mystery_win": [
    58000,
    1682.811791383223
  ],
  "level_progress_add": [
    61000,
    866.6666666666672
  ],
  "level_progress_close": [
    63000,
    1500
  ],
  "max_win": [
    66000,
    3000
  ],
  "mega_win": [
    70000,
    3500
  ],
  "multiplier_appear": [
    75000,
    893.6281179138348
  ],
  "mystery_land": [
    77000,
    998.9115646258568
  ],
  "mystery_reveal_fast": [
    79000,
    1500
  ],
  "mystery_reveal_slow": [
    82000,
    3000
  ],
  "no_win": [
    86000,
    3000
  ],
  "reel_stop": [
    90000,
    299.99999999999716
  ],
  "scatter_door": [
    92000,
    1112.5850340136053
  ],
  "scatter_land": [
    95000,
    799.9999999999972
  ],
  "scatter_lose": [
    97000,
    1827.7551020408112
  ],
  "scatter_win": [
    100000,
    1000
  ],
  "spin": [
    102000,
    189.99999999999773
  ],
  "super_mega_win": [
    104000,
    3000
  ],
  "tap_to_continue": [
    108000,
    500
  ],
  "total_win": [
    110000,
    3500
  ],
  "trail_sound": [
    115000,
    500
  ],
  "transition": [
    117000,
    1051.4739229024883
  ],
  "upgrade": [
    120000,
    1000
  ],
  "win_animation_end": [
    122000,
    2000
  ],
  "win_line": [
    125000,
    1000
  ],
  "expanding_wild": [
    127000,
    1319.9999999999932
  ],
  "condensation_drip": [
    130000,
    449.99999999998863
  ]
};
